export default function getInitState() {
    return {
        employabilitySicknessNonValidatedDocumentsDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        employabilitySicknessNonValidatedDocumentsRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'selectDocument'
            },
        ],
        employabilitySicknessNonValidatedDocumentsHeaderFields: [
            {
                name: "sicknessDueToWork",
                label: "Munkakör",
                visibility: true,
                slot_name: "isNull",
            },
            {
                name: "diagnose.text",
                label: "Diagnózis",
                visibility: true,
                formType: 'select',
                slot_name: "isNull2",
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ]
    }
}
